<template>
  <div class="board-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>设备管理</el-breadcrumb-item>
      <el-breadcrumb-item>智控设备</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索栏 -->
    <div class="search-bar">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="设备编号">
          <el-input v-model="formInline.device_sn" placeholder="请输入设备编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="设备状态">
          <el-select v-model="formInline.status" placeholder="请选择状态" clearable>
            <el-option label="在线" value="online"></el-option>
            <el-option label="离线" value="offline"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="绑定状态">
          <el-select v-model="formInline.bind_status" placeholder="请选择绑定状态" clearable>
            <el-option label="已绑定" value="1"></el-option>
            <el-option label="未绑定" value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" icon="el-icon-search">查询</el-button>
          <el-button @click="resetSearchForm" icon="el-icon-refresh">重置</el-button>
          <el-button type="success" @click="handleAdd" icon="el-icon-plus">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      v-loading="loading"
      border
      style="width: 100%"
      stripe>
      <el-table-column prop="device_sn" label="设备编号" min-width="150" align="center"></el-table-column>
      <el-table-column prop="status" label="设备状态" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 'online' ? 'success' : 'danger'">
            {{ scope.row.status === 'online' ? '在线' : '离线' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="shop_name" label="店铺名称" min-width="150" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.shop_name || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="room_name" label="包厢名称" min-width="150" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.room_name || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="heart_time" label="心跳时间" min-width="160" align="center"></el-table-column>
      <el-table-column prop="sn" label="SN号" min-width="150" align="center"></el-table-column>
      <el-table-column prop="sim" label="SIM卡" min-width="120" align="center"></el-table-column>
      <el-table-column prop="bind_status" label="绑定状态" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.bind_status === 1 ? 'success' : 'warning'">
            {{ scope.row.bind_status === 1 ? '已绑定' : '未绑定' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="指令域名" min-width="200" align="center">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.url" placement="top" effect="light">
            <span class="single-line">{{ scope.row.url }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="hardware_url" label="第三方指令" min-width="200" align="center">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.hardware_url" placement="top" effect="light">
            <span class="single-line">{{ scope.row.hardware_url }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="is_bt" label="是否蓝牙开锁" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_bt === 1 ? 'primary' : 'info'">
            {{ scope.row.is_bt === 1 ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="device_type" label="设备类型" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.device_type === 'qp' ? 'primary' : 'success'">
            {{ scope.row.device_type === 'qp' ? '棋牌' : '台球' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="is_open" label="磁吸锁是否常开" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_open === 1 ? 'danger' : 'info'">
            {{ scope.row.is_open === 1 ? '常开' : '关闭' }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="120" align="center">
        <template slot-scope="scope">
          <template v-if="!(scope.row.org_id != 53 && scope.row.bind_status === 1)">
            <el-button 
              size="mini" 
              :type="scope.row.bind_status === -1 ? 'primary' : 'warning'"
              @click="handleBind(scope.row)">
              {{ scope.row.bind_status === -1 ? '绑定' : '换绑' }}
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="480px"
      :close-on-click-modal="false"
      @close="resetDialogForm"
      class="device-dialog">
      <el-form :model="form" :rules="rules" ref="deviceForm" label-width="100px" label-position="left">
        <div class="dialog-section">
          <el-form-item label="设备编号" prop="device_sn">
            <el-input 
              v-model="form.device_sn" 
              placeholder="请输入设备编号，多个用英文逗号分隔"
              type="textarea"
              :rows="3"
              maxlength="500"
              show-word-limit>
            </el-input>
          </el-form-item>
        </div>
        
        <div class="dialog-section">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="设备来源" prop="device_from">
                <el-select v-model="form.device_from" placeholder="请选择" style="width: 100%" @change="handleDeviceFromChange">
                  <el-option label="智娱设备" :value="1"></el-option>
                  <el-option label="纷享设备" :value="2"></el-option>
                  <el-option label="5.0液晶主板" :value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设备类型" prop="device_type">
                <el-select v-model="form.device_type" placeholder="请选择" style="width: 100%">
                  <el-option label="棋牌" value="qp"></el-option>
                  <el-option label="台球" value="tq"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="dialog-section">
          <el-form-item label="选择店铺" prop="shop_id">
            <el-select 
              v-model="form.shop_id" 
              placeholder="请选择店铺"
              filterable
              remote
              :remote-method="searchShops"
              :loading="shopLoading"
              style="width: 100%"
              clearable>
              <el-option 
                v-for="item in shopOptions" 
                :key="item.id" 
                :label="item.name" 
                :value="item.id">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">ID:{{ item.id }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="medium">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitLoading" size="medium">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 绑定/换绑界面 -->
    <el-dialog :title="bindTitle" :visible.sync="bindFormVisible" width="30%" @click="closeDialog('bindForm')">
      <el-form label-width="120px" :model="bindForm" :rules="bindRules" ref="bindForm">
        <el-form-item label="设备编号">
          <el-input size="small" v-model="bindForm.device_sn" disabled></el-input>
        </el-form-item>
        <el-form-item label="选择店铺" prop="shop_name">
          <el-select 
            size="small" 
            v-model="bindForm.shop_id" 
            placeholder="请选择店铺"
            filterable
            remote
            :remote-method="searchShops"
            :loading="shopLoading"
            @change="handleShopChange"
            style="width: 100%">
            <el-option 
              v-for="item in shopOptions" 
              :key="item.id" 
              :label="item.name" 
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择包厢" prop="room_name">
          <el-select 
            size="small" 
            v-model="bindForm.room_id" 
            placeholder="请先选择店铺"
            :disabled="!bindForm.shop_id"
            style="width: 100%">
            <el-option 
              v-for="item in roomOptions" 
              :key="item.id" 
              :label="item.name" 
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('bindForm')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="bindSubmitForm('bindForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { device, addDevice, bindDevice, unbindDevice } from '@/api/device'
import { getShopList,getRoomList } from '@/api/shop'
import { roomDevice } from '@/api/shop'

export default {
  name: 'Board',
  data() {
    return {
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      formInline: {
        device_sn: '',
        status: '',
        bind_status: ''
      },
      dialogVisible: false,
      dialogTitle: '',
      form: {
        device_sn: '',
        device_from: '',
        device_type: 'qp',
        sn: '',
        sim: '',
        url: '',
        hardware_url: '',
        is_bt: 0,
        is_open: 0,
        shop_id: '',
        room_id: ''
      },
      rules: {
          device_sn: [
            { required: true, message: '请输入设备编号', trigger: 'blur' }
          ],
          device_from: [
            { required: true, message: '请选择设备来源', trigger: 'change' }
          ],
          device_type: [
            { required: true, message: '请选择设备类型', trigger: 'change' }
          ],
          shop_id: [
            { required: true, message: '请选择店铺', trigger: 'change' }
          ]
        },
      submitLoading: false,
      isEdit: false,
      bindFormVisible: false,
      bindTitle: '绑定设备',
      bindForm: {
        device_id: '',
        device_sn: '',
        shop_id: '',
        room_id: ''
      },
      shopOptions: [],
      roomOptions: [],
      org_id:this.$globalConfig.orgId,
      shopLoading: false,
      bindRules: {
        shop_id: [
          { required: true, message: '请选择店铺', trigger: 'change' }
        ],
        room_id: [
          { required: true, message: '请选择包厢', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          limit: this.pageSize,
          ...this.formInline
        }
        const res = await device(params)
        if (res.code === 1) {
          this.tableData = res.data.data || []
          this.total = res.data.total || 0
        } else {
          this.$message.error(res.data.msg || '获取数据失败')
        }
      } catch (error) {
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },
    onSubmit() {
      this.currentPage = 1
      this.loadData()
    },
    resetSearchForm() {
      this.formInline = {
        device_sn: '',
        status: '',
        bind_status: ''
      }
      this.currentPage = 1 // 重置到第一页
      this.loadData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    handleAdd() {
      this.isEdit = false
      this.dialogTitle = '新增设备'
      this.form = {
        device_sn: '',
        device_from: '',
        device_type: 'qp',
        sn: '',
        sim: '',
        url: '',
        hardware_url: '',
        is_bt: 0,
        is_open: 0,
        shop_id: '',
        room_id: ''
      }
      this.dialogVisible = true
      // 加载店铺列表
      this.searchShops('')
    },
    handleDeviceFromChange(value) {
      if (value === 1) {
        this.$message({
          message: '智娱（K8主板、K5锁球器）设备编号只有数字0，没有字母O',
          type: 'warning',
          duration: 3000
        });
      }
    },
    handleEdit(row) {
      this.isEdit = true
      this.dialogTitle = '编辑设备'
      this.form = { 
        device_sn: row.device_sn,
        sn: row.sn,
        sim: row.sim,
        url: row.url,
        hardware_url: row.hardware_url,
        device_type: row.device_type,
        is_bt: row.is_bt,
        is_open: row.is_open,
        shop_id: row.shop_id || '',
        room_id: row.room_id || ''
      }
      this.dialogVisible = true
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该设备吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        // 这里需要调用删除API
        this.$message.success('删除成功')
        this.loadData()
      } catch (error) {
        this.$message.info('已取消删除')
      }
    },
    async handleBind(row) {
      this.bindTitle = row.bind_status === -1 ? '绑定设备' : '换绑设备'
      this.bindForm.device_id = row.id
      this.bindForm.device_sn = row.device_sn
      this.bindForm.shop_id = ''
      this.bindForm.room_id = ''
      this.bindFormVisible = true
      
      // 加载店铺列表
      await this.searchShops('')
      
      // 如果设备已绑定，自动回填店铺和包厢
      if (row.bind_status !== -1 && row.shop_id && row.room_id) {
        // 设置已绑定的店铺
        this.bindForm.shop_id = row.shop_id
        
        // 加载该店铺下的包厢
        await this.loadRoomsByShop(row.shop_id)
        
        // 设置已绑定的包厢
        this.bindForm.room_id = row.room_id
      }
    },
    async searchShops(query) {
      this.shopLoading = true;
      try {
        const org = this.org_id || 53
        const params = { name: query, page: 1, limit: 100, org_id: org}
        const res = await getShopList(params)
        if (res.code === 1) {
          this.shopOptions = res.data || []
        } else {
          this.$message.error('获取店铺列表失败')
        }
      } catch (error) {
        this.$message.error('获取店铺列表失败')
      } finally {
        this.shopLoading = false
      }
    },
    handleShopChange(shopId) {
      this.bindForm.room_id = ''
      this.roomOptions = []
      if (shopId) {
        this.loadRoomsByShop(shopId)
      }
    },
    
    async loadRoomsByShop(shopId) {
      this.loading = true
      try {
        const params = { shop_id: shopId}
        const res = await getRoomList(params)
        if (res.code === 1) {
          this.roomOptions = res.data || []
        } else {
          this.$message.error('获取包厢列表失败')
        }
      } catch (error) {
        this.$message.error('获取包厢列表失败')
      } finally {
        this.loading = false
      }
    },
    bindSubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true
          const params = {
            device_id: this.bindForm.device_id,
            shop_id: this.bindForm.shop_id,
            room_id: this.bindForm.room_id
          }
          bindDevice(params).then(res => {
            this.loading = false
            if (res.code == 1) {
              this.$message.success('设备绑定成功')
              this.bindFormVisible = false
              this.loadData()
            } else {
              this.$message.error(res.msg || '设备绑定失败')
            }
          }).catch(() => {
            this.loading = false
            this.$message.error('设备绑定失败')
          })
        }
      })
    },
    closeDialog(formName) {
      if (formName === 'bindForm') {
        this.bindFormVisible = false
        this.$refs['bindForm'].resetFields()
        this.shopOptions = []
        this.roomOptions = []
      }
    },
    submitForm() {
      this.$refs.deviceForm.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            const api = this.isEdit ? addDevice : addDevice
            const res = await api(this.form)
            if (res.code == 1) {
              this.$message.success(this.isEdit ? '编辑成功' : '新增成功')
              this.dialogVisible = false
              this.loadData()
            } else {
              this.$message.error(res.data.msg || '操作失败')
            }
          } catch (error) {
            this.$message.error('操作失败')
          } finally {
            this.submitLoading = false
          }
        }
      })
    },
    resetDialogForm() {
      this.$refs.deviceForm && this.$refs.deviceForm.resetFields()
    }
  }
}
</script>

<style scoped>
.board-container {
  padding: 20px;
  background-color: #f5f5f5;
}

.search-bar {
  background: white;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.action-bar {
  background: white;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.single-line {
  display: inline-block;
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<style scoped>
.device-dialog .el-dialog__header {
  border-bottom: 1px solid #ebeef5;
  padding: 20px 24px;
}

.device-dialog .el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.device-dialog .el-dialog__body {
  padding: 24px;
}

.device-dialog .el-form-item {
  margin-bottom: 20px;
}

.device-dialog .el-form-item__label {
  font-weight: 500;
  color: #606266;
  line-height: 32px;
}

.device-dialog .el-form-item__content {
  line-height: 32px;
}

.device-dialog .dialog-section {
  margin-bottom: 8px;
}

.device-dialog .dialog-section:last-child {
  margin-bottom: 0;
}

.device-dialog .el-textarea .el-textarea__inner {
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 13px;
  line-height: 1.5;
}

.device-dialog .el-select .el-input__inner {
  height: 36px;
  line-height: 36px;
}

.device-dialog .el-dialog__footer {
  border-top: 1px solid #ebeef5;
  padding: 16px 24px;
  text-align: right;
}

.device-dialog .el-button--medium {
  padding: 10px 20px;
  font-size: 14px;
}

.device-dialog .el-select-dropdown__item {
  height: 36px;
  line-height: 36px;
  padding: 0 12px;
}

.device-dialog .el-select-dropdown__item span:last-child {
  margin-left: 8px;
}
</style>


// WEBPACK FOOTER //
// src/views/device/Board.vue